<app-header></app-header>
<div class="content-wrapper">
  <div *ngIf="isGigatonRoute()" class="carbon-wrap">
    <img src="assets/images/goals-v2/carbon-footprint.jpg" class="carbon-img" alt="">
    <a class="back-to-result" [routerLink]="[searchListPage]">
      {{"GIGATON.FOOTPRINT_HEADING" | translate}}
    </a>
  </div>
  <div *ngIf="isCarbonFootprintRoute()" class="carbon-wrap">
    <a class="back-to-wrap" [routerLink]="[searchPage]">
      {{"Gigaton_Calculator" | translate}}
    </a>
  </div>
  <div class="ppl-main-heading-wrap" *ngIf="isPeopleRouteActive()">
    <div class="ppl-goals-heading">{{ "PEOPLE.TITLE" | translate }}</div>
    <div class="ppl-goals-first-sub-heading d-flex">
      <span class="ppl-sub-head-txt">{{ "PEOPLE.TITLE_DESC" | translate }}</span>
    </div>
  </div>
    <mat-card class="p-30">
        <router-outlet></router-outlet>
    </mat-card>
</div>
<app-footer></app-footer>
